
export { default as CreateSolvedPaper } from './CreateSolvedPaper';
export { default as EditSolvedPaper} from './EditSolvedPaper';
export { default as SolvedPaperList } from './SolvedPaperList';
export { default as Header } from '../Header';
export { default as AdminNavbar } from '../AdminNavbar';
export { default as Adminmain } from '../Adminmain';
